import { css, cx } from "@emotion/css";

import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { brown, grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import { ReactComponent as StarGold } from "../icons/star-gold.svg";
import { ReactComponent as StarSilver } from "../icons/star-silver.svg";

type LevelNumberProps = {
  level: number;
  active: boolean;
};

export const LevelNumber: React.FC<LevelNumberProps> = ({ level, active }) => {
  const classes = createLevelNumberStyles(useTheme());
  return (
    <div className={classes.levelNumberWrapper}>
      <Typography
        variant="contentMedium"
        className={cx(classes.levelNumber, {
          [classes.silverFont]: !active,
        })}
      >
        {level} {active}
      </Typography>
      {active ? <StarGold /> : <StarSilver />}
    </div>
  );
};

function createLevelNumberStyles({ spacing }: Theme) {
  return {
    levelNumberWrapper: css({
      position: "absolute",
      bottom: spacing(-2),
      right: spacing(-2),
    }),
    levelNumber: css({
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      color: brown[600],
    }),
    silverFont: css({
      color: grey[500],
    }),
  };
}
